module.exports = __webpack_public_path__ + "img/service-details-2.6c77606e.jpg";